function triggerZasuwaProductScan(root) {
  if (window.ZasuwaInsights && typeof window.ZasuwaInsights.scanProducts === 'function') {
    window.ZasuwaInsights.scanProducts(root);
  }
}

(function () {
  const collectionSortAllowlist = new Set([
    'manual',
    'most-relevant',
    'best-selling',
    'title-ascending',
    'title-descending',
    'price-ascending',
    'price-descending',
    'created-ascending',
    'created-descending',
  ]);

  let baseGridNormalizationRequested = false;
  let baseGridNormalizationInFlight = false;
  let baseGridNormalizationWaitingForFacetFiltersForm = false;

  function normalizeTokens(value) {
    if (!value) return [];

    const seen = new Set();
    return value
      .split(',')
      .map((token) => token.trim().toLowerCase())
      .filter((token) => {
        if (!token || seen.has(token)) return false;
        seen.add(token);
        return true;
      });
  }

  function parseSortState(rawSortBy) {
    const tokens = normalizeTokens(rawSortBy);
    const baseSort = tokens.length && collectionSortAllowlist.has(tokens[0]) ? tokens[0] : null;

    return {
      raw: rawSortBy || '',
      tokens,
      baseSort,
      pins: baseSort ? tokens.slice(1) : tokens,
    };
  }

  function getSortState() {
    if (window.ZasuwaCollectionSort && typeof window.ZasuwaCollectionSort.getCurrentSortState === 'function') {
      return window.ZasuwaCollectionSort.getCurrentSortState();
    }

    return parseSortState(new URLSearchParams(window.location.search).get('sort_by'));
  }

  function getFacetFiltersFormClass() {
    if (!window.customElements || typeof window.customElements.get !== 'function') {
      return null;
    }

    return window.customElements.get('facet-filters-form');
  }

  function buildSanitizedShopifyParams(search, sortState) {
    if (window.ZasuwaCollectionSort && typeof window.ZasuwaCollectionSort.buildShopifyRequestParams === 'function') {
      return window.ZasuwaCollectionSort.buildShopifyRequestParams(search, sortState);
    }

    const requestParams = new URLSearchParams(search || window.location.search);
    const nextSortState = sortState || getSortState();

    if (!nextSortState.pins.length) {
      return requestParams;
    }

    if (nextSortState.baseSort) {
      requestParams.set('sort_by', nextSortState.baseSort);
    } else {
      requestParams.delete('sort_by');
    }

    return requestParams;
  }

  function isCollectionGridPage() {
    if (window.ZasuwaCollectionSort && typeof window.ZasuwaCollectionSort.isCollectionGridPage === 'function') {
      return window.ZasuwaCollectionSort.isCollectionGridPage();
    }

    return Boolean(document.querySelector('#product-grid[data-collection-handle]'));
  }

  function getProductGrid() {
    return document.querySelector('#product-grid[data-collection-handle]');
  }

  function buildCardUrl(collectionHandle, productHandle) {
    const root = window.Shopify?.routes?.root || '/';
    const productUrl = `${root}products/${encodeURIComponent(productHandle)}`;
    const searchParams = new URLSearchParams({
      section_id: 'zasuwa-product-card-endpoint',
    });

    if (collectionHandle) {
      searchParams.set('collection_handle', collectionHandle);
    }

    return `${productUrl}?${searchParams.toString()}`;
  }

  function parseProductCard(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    return parsed.querySelector('[data-product-handle]');
  }

  function escapeAttributeValue(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return value.replace(/["\\]/g, '\\$&');
  }

  async function fetchProductCard(collectionHandle, productHandle) {
    const response = await fetch(buildCardUrl(collectionHandle, productHandle));
    if (!response.ok) return null;

    const html = await response.text();
    const card = parseProductCard(html);
    if (!card || card.dataset.productHandle !== productHandle) return null;

    return card;
  }

  async function applyPinnedProducts() {
    const sortState = getSortState();
    const handles = sortState.pins || [];
    if (!handles.length) return;

    if (!isCollectionGridPage()) return;

    const searchParams = new URLSearchParams(window.location.search);
    const page = searchParams.get('page');
    if (page && Number(page) !== 1) return;

    const grid = getProductGrid();
    if (!grid || grid.dataset.zasuwaPinnedSortApplied === 'true') return;
    grid.dataset.zasuwaPinnedSortApplied = 'true';

    const collectionHandle = grid.dataset.collectionHandle;
    const pinnedCards = [];

    for (const handle of handles) {
      try {
        const card = await fetchProductCard(collectionHandle, handle);
        if (!card) continue;

        grid.querySelectorAll(`[data-product-handle="${escapeAttributeValue(handle)}"]`).forEach((existingCard) => {
          existingCard.remove();
        });

        pinnedCards.push(card);
      } catch (error) {
        console.warn('Pinned collection product skipped:', handle, error);
      }
    }

    for (let index = pinnedCards.length - 1; index >= 0; index -= 1) {
      grid.insertBefore(pinnedCards[index], grid.firstElementChild);
    }

    triggerZasuwaProductScan(grid);
  }

  function refreshPinnedProductsIfNeeded() {
    if (!isCollectionGridPage()) return;
    const sortState = getSortState();
    if (!sortState.pins.length) return;

    if (baseGridNormalizationRequested || baseGridNormalizationInFlight) return;

    const facetFiltersForm = getFacetFiltersFormClass();
    if (facetFiltersForm && typeof facetFiltersForm.renderPage === 'function') {
      baseGridNormalizationRequested = true;
      baseGridNormalizationInFlight = true;
      facetFiltersForm.renderPage(buildSanitizedShopifyParams(window.location.search, sortState).toString(), null, false);
      return;
    }

    if (baseGridNormalizationWaitingForFacetFiltersForm) return;

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      baseGridNormalizationWaitingForFacetFiltersForm = true;
      window.customElements.whenDefined('facet-filters-form').then(() => {
        baseGridNormalizationWaitingForFacetFiltersForm = false;

        if (baseGridNormalizationRequested || baseGridNormalizationInFlight) return;

        const readyFacetFiltersForm = getFacetFiltersFormClass();
        if (!readyFacetFiltersForm || typeof readyFacetFiltersForm.renderPage !== 'function') return;

        baseGridNormalizationRequested = true;
        baseGridNormalizationInFlight = true;
        readyFacetFiltersForm.renderPage(
          buildSanitizedShopifyParams(window.location.search, sortState).toString(),
          null,
          false
        );
      });
    }
  }

  document.addEventListener('zasuwa:collection-grid-rendered', () => {
    baseGridNormalizationInFlight = false;
    applyPinnedProducts();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshPinnedProductsIfNeeded);
  } else {
    refreshPinnedProductsIfNeeded();
  }
})();
